export type VectroResourceType =
        | 'dashboard'
        | 'users'
        | 'orders'
        | 'tariffs'
        | 'pricingPolicies'
        | 'limitPolicies'
        | 'limits'
        | 'scenarios'
        | 'tariffTypes'
        | 'campaigns'
        | 'vouchers'
        | 'contracts'
        | 'vehicles'
        | 'customers'
        | 'parkingSessions'
        | 'gateMonitor'
        | 'gates';

export const VectroResource: Record<VectroResourceType, VectroResourceType> = {
        dashboard: 'dashboard',
        users: 'users',
        orders: 'orders',
        tariffs: 'tariffs',
        pricingPolicies: 'pricingPolicies',
        limitPolicies: 'limitPolicies',
        limits: 'limits',
        scenarios: 'scenarios',
        tariffTypes: 'tariffTypes',
        campaigns: 'campaigns',
        vouchers: 'vouchers',
        contracts: 'contracts',
        vehicles: 'vehicles',
        customers: 'customers',
        parkingSessions: 'parkingSessions',
        gateMonitor: 'gateMonitor',
        gates: 'gates'
};
